




import VueOptions from '@utils/VueOptions'
import BrandInfoCreate from '@superComponents/BrandInfo/BrandInfoCreate'

settings = 
  name: "BrandInfoCreatePage"
  components: { BrandInfoCreate }

export default VueOptions.vue settings
